import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AddBlockedPhoneNumberState, addBlockedPhoneNumberFeatureKey } from './add-blocked-phone-number.reducer';

const getAddBlockedPhoneNumberFeature = createFeatureSelector<AddBlockedPhoneNumberState>(
   addBlockedPhoneNumberFeatureKey
);

export const getAddBlockedPhoneNumberCallState = createSelector(getAddBlockedPhoneNumberFeature, (state) => {
   return state.callState;
});
